/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { useParams } from 'react-router';
import * as S from './LocalAppInstallPostbackPage.styled';
import {
  LocalizationLinkedList,
  PreviewApp,
  AppInstallPostbackForm,
  Loader,
  ErrorComponent,
} from 'components';
import { publisherLocalizationPages } from 'constants';
import { routes } from 'config';
import { getUrl } from 'utils';
import { manageAppsAPI } from 'services/manageApps.service';
import { useSelector } from 'react-redux';

const getPages = (pba_id) =>
  publisherLocalizationPages.map((page) => {
    return { ...page, link: getUrl(routes, page.url_id, pba_id) };
  });

const LocalAppInstallPostbackPage = () => {
  const { pba_id } = useParams();

  const isAdvertiser = useSelector((state) => state.auth.pb_roles).includes('advertiser');

  const {
    //postBackUrl, pba_name, platform,
    isSuccess,
    isError,
    data,
  } = manageAppsAPI.useFetchAppAdvancedDataQuery(
    { pba_id, isAdvertiser },
    {
      selectFromResult: ({ data, isError, isSuccess }) => {
        return {
          postBackUrl: data?.postBackUrl,
          pba_name: data?.pba_name,
          platform: data?.platform_name,
          isError: isError,
          isSuccess: isSuccess,
          data,
        };
      },
    },
  );

  if (isError) {
    return <ErrorComponent />;
  }

  return (
    <>
      {!isSuccess && !isError && <Loader.Global delay={1} />}
      {data && (
        <S.Container>
          <S.ListPosition>
            <PreviewApp />
            <LocalizationLinkedList data={getPages(pba_id)} show={true} />
          </S.ListPosition>
          <S.Main>
            <h1 style={{ textAlign: 'start', width: '100%' }}>App Settings</h1>
            <S.Wrap>
              <AppInstallPostbackForm {...data} />
            </S.Wrap>
          </S.Main>
        </S.Container>
      )}
    </>
  );
};

export default LocalAppInstallPostbackPage;
